import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { Segmented } from 'antd';
const SegmentComponent = ({ initialValue, options, onChange, disabled }) => {
    const [value, setValue] = React.useState(initialValue);
    const handleChange = (newValue) => {
        setValue(newValue);
        onChange(newValue);
    };
    return _jsx(Segmented, { options: options, value: value, onChange: handleChange, disabled: disabled });
};
export default SegmentComponent;
